import { CouponCode, CouponCodeStatus, CouponCodeWithCoupon } from "./CouponCode";
import { MembershipCode } from "./MembershipCode";

/** TODO: Find a better name for this */
export interface RewardCode {
    id?: ID;
    code: string;
    status?: number;
    uses: number;
}

export enum RewardCodeObject {
    COUPON = "coupon_code",
    MEMBERSHIP = "membership_code",
}

export type AnyRewardCode = MembershipCode | CouponCodeWithCoupon;

export const isActive = (code: RewardCode) => code.status === CouponCodeStatus.ACTIVE;

export const isCouponCode = (code: AnyRewardCode): code is CouponCode => {
    return "coupon" in code && !code.coupon?.giftPurchaseItem;
};

export const isGiftCode = (code: AnyRewardCode): code is CouponCode => {
    return "coupon" in code && !!code.coupon?.giftPurchaseItem;
};

export const isMembershipCode = (code: AnyRewardCode): code is MembershipCode => {
    return "membershipItem" in code;
};
